"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    container: 'c-AnchorInput',
    inputs: 'c__AnchorInput__inputs',
    error: 'c-AnchorInput__error',
    leftInput: 'c-AnchorInput__leftInput',
    rightInput: 'c-AnchorInput__rightInput',
    relatedSpans: 'c-AnchorInput__relatedSpans',
    MDL: {
        error: 'mdl-textfield__error'
    }
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'block',
        margin: '8px 0',
        width: '100%'
    },
    [exports.CSS.inputs]: {
        flex: 1,
        display: 'flex',
        'justify-content': 'space-between',
        [`& .${exports.CSS.leftInput}`]: {
            width: '60%'
        },
        [`& .${exports.CSS.rightInput}`]: {
            width: '40%'
        }
    },
    [exports.CSS.error]: {
        visibility: 'visible',
        position: 'relative'
    },
    [exports.CSS.relatedSpans]: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    }
};
//# sourceMappingURL=anchor.input.style.js.map